import { useGiftCardBalance } from '@olo-web/domain';
import { useMerchant } from '@domain/merchants/queries/useMerchant';
import { useOrder } from '@olo-web/domain/orders/queries/useOrder';
import { useTipAmount } from '@olo-web/domain/orders/hooks/useTipAmount';
import { useIsStartATabModal } from '@olo-web/utils/common/hooks/useIsStartATabModal';
import { useCustomPaymentAmount } from '@olo-web/domain/orders/hooks';
import { calculateMixedPaymentAmounts } from '@olo-web/domain/orders/functions/calculateMixedPaymentAmounts';

export const useCalculateMixedPayment = () => {
  const { data: order } = useOrder();
  const tip = +useTipAmount();
  const { data: giftCard } = useGiftCardBalance();
  const orderBalanceDue = +order?.balanceDueAmount || 0;
  const giftCardBalance = +giftCard?.remainingBalanceAmount || 0;
  const { data: merchant } = useMerchant();
  const isStartATab = useIsStartATabModal();
  const { total: customPaymentTotal } = useCustomPaymentAmount();

  const preauthAmount = Math.max(
    Number(order?.balanceDueAmount),
    Number(merchant?.defaulttabamount || 0)
  );

  const balanceDue = customPaymentTotal ?? orderBalanceDue;

  return calculateMixedPaymentAmounts({
    orderBalanceDue: balanceDue,
    giftCardBalance,
    tip,
    isStartATab,
    preauthAmount,
  });
};
